import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainRoutes } from '../../guards/guard.models';
import { SessionGuard } from '../../guards/session/session.guard';
import { MainRequestsListComponent } from '../../shared/main-requests-list/main-requests-list.component';
import { NewStreetNamingRequestComponent } from './new-street-naming-request/new-street-naming-request.component';
import { StreetNamingPortalComponent } from './street-naming-portal.component';

const streetNamingPortalRoutes: Routes = [
  {
    path: MainRoutes.StreetNaming,
    component: StreetNamingPortalComponent,
    canActivate: [SessionGuard],
    children: [
      {
        path: '',
        redirectTo: 'new-request',
        pathMatch: 'full',
      },
      {
        path: 'new-request',
        component: NewStreetNamingRequestComponent,
      },
      {
        path: 'requests-list',
        component: MainRequestsListComponent,
      },
      {
        path: '**',
        redirectTo: 'new-request',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(streetNamingPortalRoutes)],
  providers: [],
  exports: [RouterModule],
})
export class StreetNamingPortalRoutingModule {}
